export const intOnlyNumbersValidations = (value?: string | undefined | null) => {
  if(!value || typeof value === 'number') {
    return false;
  }

  return /^([0-9][0-9]*|0)(\.[0-9]+)?$/.test((value).trim());
}
